import React from 'react';
import { useDispatch } from 'react-redux';
import BorrowerDashContentSC, {
  LeftContentWrapSC,
  RightContentWrapSC,
  TopContentWrapSC,
} from './borrower-dash-content.styled';
import { BodyText } from '../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import InstallmentTable from './installment-table';
import Arrears from './arrears';
import InlineLoading from '../ui/inline-loading';
import { AccessCardSC } from './AccessCard.styled';
import { logOut } from '../../redux/action';

const BorrowerDashContent = ({ dashboardData, user }) => {
  const dispatch = useDispatch();
  // Prefer user.userAreaAccess if present, fallback to dashboardData.userAreaAccess
  const userAreaAccess = (user && user.userAreaAccess) || (dashboardData && dashboardData.userAreaAccess);

  // If access is false, show accessCard immediately
  if (userAreaAccess && userAreaAccess.access === false) {
    return (
      <BorrowerDashContentSC style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <AccessCardSC>
          <h2>Ukončený úver</h2>
          <p style={{ marginBottom: 32 }}>{userAreaAccess.text}</p>
          <p style={{ fontWeight: 600, marginTop: 32 }}>{userAreaAccess.greeting}</p>
          <button
            style={{
              marginTop: '24px',
              padding: '18px 48px',
              fontSize: '1.2rem',
              fontWeight: 700,
              background: '#F7931E',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(47,46,65,0.10)',
              cursor: 'pointer',
              letterSpacing: '0.5px',
              transition: 'background 0.2s',
            }}
            onClick={() => dispatch(logOut({ force: true }))}
          >
            Odhlásiť sa
          </button>
        </AccessCardSC>
      </BorrowerDashContentSC>
    );
  }

  // Loader only if dashboardData is empty and access is not false
  if (Object.keys(dashboardData).length === 0) {
    return (
      <BorrowerDashContentSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </BorrowerDashContentSC>
    );
  }

  const loanStatus = dashboardData.loans && dashboardData.loans[0]?.status?.loanStatus;
  const isClosedSpecial = loanStatus && (loanStatus.id === 10 || loanStatus.name === 'LOAN_CLOSED_SPECIAL');

  return (
    <BorrowerDashContentSC>
      <TopContentWrapSC>
        {isClosedSpecial && (
          <BodyText style={{ color: '#d35400', marginBottom: 16, fontWeight: 500 }}>
            Úver bol ukončený dohodou so spoločnosťou Wishmaker j.s.a.
          </BodyText>
        )}
        <BodyText className="bolder">
          <FormattedMessage
            id="borrower_dash_installment_calendar"
            defaultMessage={dlt['borrower_dash_installment_calendar']}
          />
        </BodyText>
      </TopContentWrapSC>
      <LeftContentWrapSC>
        <InstallmentTable
          tableData={dashboardData.loans[0].schedules}
          dueInstallmentCount={dashboardData.loans[0].status.dueInstallmentCount}
        />
      </LeftContentWrapSC>
      <RightContentWrapSC>
        <Arrears
          receivables={dashboardData.loans[0].receivables}
          forgiven={dashboardData.loans[0].communication_receivables_deleted}
          schedules={dashboardData.loans[0].schedules}
          communicationProcessingDate={dashboardData.loans[0].communicationProcessingDate}
          daysInArrears={dashboardData.loans[0].status.daysInArrears}
          actualUnpaid={dashboardData.loans[0].status.actualUnpaid}
          overpaid={dashboardData.loans[0].status.overpaid}
          isEmpty={
            Number(dashboardData.loans[0].status.overpaid) === 0 &&
            Number(dashboardData.loans[0].status.actualUnpaid) === 0 &&
            Number(dashboardData.loans[0].receivables.sms) === 0 &&
            Number(dashboardData.loans[0].receivables.email) === 0 &&
            Number(dashboardData.loans[0].receivables.letter) === 0 &&
            Number(dashboardData.loans[0].receivables.call) === 0
          }
        />
      </RightContentWrapSC>
    </BorrowerDashContentSC>
  );
};

export default BorrowerDashContent;
